// Purpose: Define LGV's versioned, privacy-safe site-journey event contract.
// Features: Maps journey stages to GA4 and first-party tracking ownership.
// Dependencies: None. Important: never permit personal or sensitive data in GA4.

export const JOURNEY_CATALOG_VERSION = 1;
export const JOURNEY_EVENTS = Object.freeze({
  PAGE_VIEWED: { stage: "landing_or_discovery", ga4: "page_view", lgv: null },
  EVENT_PAGE_VIEWED: { stage: "event_engagement", ga4: "event_page_viewed", lgv: null },
  SIGN_UP_COMPLETED: { stage: "sign_up_or_login", ga4: "sign_up", lgv: null },
  LOGIN_COMPLETED: { stage: "sign_up_or_login", ga4: "login", lgv: null },
  VOTE_ACCEPTED: { stage: "conversion", ga4: "vote_submitted", lgv: "integrity_audit" },
  PASSPORT_VIEWED: { stage: "event_engagement", ga4: "passport_viewed", lgv: "engagement_events" },
  PASSPORT_ACTIVITY_COMPLETED: { stage: "conversion", ga4: "passport_code_redeemed", lgv: "engagement_transactions" },
  AUCTION_BID_ACCEPTED: { stage: "conversion", ga4: "auction_bid_placed", lgv: "auctionBids" },
  STORE_CHECKOUT_STARTED: { stage: "conversion", ga4: "store_checkout_started", lgv: "orders" },
});

export const GA4_ALLOWED_PARAMETERS = new Set([
  "journey_catalog_version", "journey_stage", "event_slug", "event_id",
  "source", "source_page", "validation_method", "points_awarded",
  "item_type", "voting_type", "action", "method", "interaction_type",
  "commerce_type", "result", "failure_reason", "return_window",
]);

const stages = {
  acquisition: ["request_event_submitted", "contact_form_submitted", "event_interest_submitted", "event_search_submitted", "event_search_not_found", "mailing_list_signup"],
  identity: ["register_submitted", "login_success", "password_reset_requested", "password_reset_completed"],
  discovery: ["entry_list_viewed", "entry_viewed", "sponsor_list_viewed", "sponsor_viewed", "vendor_list_viewed", "vendor_viewed", "auction_list_viewed", "auction_item_viewed", "event_page_viewed", "event_schedule_viewed", "event_map_viewed", "auction_search_submitted"],
  engagement: ["event_returned", "vote_page_viewed", "vote_submit_clicked", "manual_vote_viewed", "passport_scanner_opened", "passport_qr_scanned", "passport_stop_viewed", "passport_stop_redeemed", "schedule_item_saved", "volunteer_opportunities_viewed", "sponsor_website_clicked", "vendor_website_clicked", "ballot_viewed", "leaderboard_viewed"],
  conversion: ["vote_submitted", "manual_vote_submitted", "passport_code_redeemed", "auction_bid_placed", "auction_registration_started", "auction_registration_completed", "auction_checkout_started", "checkout_failed", "checkout_cancelled", "store_checkout_started", "ticket_checkout_started", "sponsor_checkout_started", "vendor_checkout_started", "public_entry_submitted", "sponsor_inquiry_submitted", "vendor_inquiry_submitted", "volunteer_signup_submitted"],
};

export const resolveJourneyStage = (eventName = "") => Object.entries(stages)
  .find(([, names]) => names.includes(eventName))?.[0] || "other";

export const classifyJourneyRoute = (path = "") => {
  const cleanPath = String(path).split("?")[0].split("#")[0];
  if (cleanPath === "/") return "landing";
  if (/^\/(login|register|reset)/.test(cleanPath)) return "identity";
  if (/\/(vote|ballot|manual_vote)/.test(cleanPath)) return "voting";
  if (/\/(passport|passport_stop|passport_achievements)/.test(cleanPath)) return "passport";
  if (/\/(auction|store|buy_tickets)/.test(cleanPath)) return "commerce";
  if (/^\/[^/]+\/(event|entries|sponsors|vendors)/.test(cleanPath)) return "event_discovery";
  return "discovery";
};
